import { render, staticRenderFns } from "./notificationSettings.vue?vue&type=template&id=0f05fb5a"
import script from "./notificationSettings.vue?vue&type=script&lang=js"
export * from "./notificationSettings.vue?vue&type=script&lang=js"
import style0 from "./notificationSettings.vue?vue&type=style&index=0&id=0f05fb5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports